import { SxProps, Theme } from "@mui/material";

export const dateAndTimeFareharborStyles = {
    checkAvailabilityText: (theme: Theme): SxProps<Theme> => ({
        fontSize: 24,
        fontFamily: theme.typography.fontFamily,
        fontWeight: 700,
        marginBottom: 1,
    }),
    calendarBox: {
        paddingBottom: 0.5,
        display: "flex",
        flexDirection: "row",
        alignItems: "end",
        gap: 3,
    },
    datePickerBox: {
        flex: 1,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        paddingBottom: 0.5,
        backgroundColor: "white",
        borderRadius: "8px",
        padding: "13px 8px",
        boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.25)",
    },
    dateText: (theme: Theme): SxProps<Theme> => ({
        fontSize: "17px",
        fontFamily: theme.typography.fontFamily,
        fontWeight: 400,
        color: "#000",
    }),
    dropdownIcon: {
        width: "12px", height: "7px"
    },
    timePickerBox: {
        flex: 1,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.25)",
    },
    selectBox: {
        width: "100%",
    },
    selectInputTime: {
        borderRadius: "8px",
        backgroundColor: "white",
        border: "none",
        "& .MuiOutlinedInput-input": {
            padding: "13px 8px",
        },
        "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
            border: "none",
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "none",
        },
        ".css-11bgdin-MuiSelect-icon": {
            top: "unset",
        },
        "& .MuiSelect-icon": {
            fontSize: "1.5rem",
            width: "12px",
            height: "7px",
        },
    },

    calendarDialog: {
        "& .MuiDialog-paper": {
            borderRadius: "8px",
        },
    },
    dateCalendar: {
        // Style for the header (Month and year text)
        "& .MuiPickersCalendarHeader-label": {
            fontSize: "20px",
            fontWeight: "500",
        },
        // Style for the navigation arrows
        "& .css-1vooibu-MuiSvgIcon-root": {
            fill: "rgb(0 0 0)",
        },
    },
    customDay: (isToday: boolean): SxProps<Theme> => ({
        ...(isToday && {
            color: "black",
            fontWeight: "bold",
            border: "none !important",
        }),
    }),

};
